import React from 'react';
import {render} from '../../src/utils/render';

export default () => {
  render('text-input', () => {
    const App = () => <input type="text" />;
    return <App />;
  });

  /*============================================================
                            SLIDE
============================================================*/

  render('text-input-reverse', () => {
    class App extends React.Component {
      state = {
        textValue: ''
      };

      setText = text => {
        this.setState({textValue: text});
      };

      render() {
        return (
          <div>
            <input
              value={this.state.value}
              onChange={e => this.setText(e.target.value)}
            />
            <div className="text">
              {' '}
              Reverse text is: <br />{' '}
              {this.state.textValue
                .split('')
                .reverse()
                .join('')}
            </div>
            <button> Post </button>
          </div>
        );
      }
    }

    return <App />;
  });

  /*============================================================
                                Clear example
    ============================================================*/

  render('text-input-clear', () => {
    class App extends React.Component {
      state = {
        textValue: ''
      };

      setText = text => {
        this.setState({textValue: text});
      };

      clearField = () => {
        this.setState({textValue: ''});
      };

      render() {
        return (
          <div>
            <input
              style={{marginBottom: 10}}
              value={this.state.textValue}
              onChange={e => this.setText(e.target.value)}
            />
            <button onClick={this.clearField}> clear </button>
          </div>
        );
      }
    }

    return <App />;
  });
};



// WEBPACK FOOTER //
// ./presentations/text-input/text-input.js